import {
  DRAGGABLE_AREA_HEIGHT,
  type DragableArea,
  type WindowPosition,
} from "@/overlay/components/window/DesktopContext";
import type { CSSProperties } from "react";

interface LayerStackWindowStyleOptions {
  draggableArea: DragableArea;
  floatingBottomOffset?: number;
  position: WindowPosition;
  style?: CSSProperties;
}

/**
 * A track constrains a managed window's height. A floating window is absolutely
 * positioned, so it needs an explicit maximum height to remain scrollable.
 */
export function getLayerStackWindowStyle({
  draggableArea,
  floatingBottomOffset = 0,
  position,
  style,
}: LayerStackWindowStyleOptions): CSSProperties | undefined {
  if (position.isManaged) {
    return style;
  }

  const top = draggableArea.top ?? DRAGGABLE_AREA_HEIGHT;
  const maxHeight =
    draggableArea.bottom === undefined
      ? `calc(100dvh - ${top + floatingBottomOffset}px)`
      : Math.max(0, draggableArea.bottom - top - floatingBottomOffset);

  return {
    ...style,
    maxHeight,
  };
}
